import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../Store";
import { User } from "../authSliceLogin/authSliceLogin";
import { API_CENTER } from "../../../services/api/api";

const initialState = {} as User;
const API = new API_CENTER();

export const API_SETTINGS_PROFILE = createAsyncThunk<
  string,
  { phone_number: string },
  {
    rejectValue: string; // указывает, что функция должна возвращать TypeReturnToken или выбрасывать ошибку типа unknown
  }
>("profileSlice/API_SETTINGS_PROFILE", async (value, { rejectWithValue }) => {
  const response = await API.GET_API("user/my", "PUT", value);
  if (response.success) {
    return value.phone_number;
  } else {
    return rejectWithValue(response); // выбросить ошибку с сообщением
  }
});

// профиль пользователя
const profileSlice = createSlice({
  name: "ROUTING_SLICE",
  initialState: initialState,
  reducers: {
    // записать информацию о пользователе
    UP_DATE_PROFILE: (state, actions: PayloadAction<User, string>) => {
      return (state = actions.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(API_SETTINGS_PROFILE.fulfilled, (state, actions) => {
      state.phone_number = actions.payload;
    });
  },
});

export const selectProfile = (state: RootState) => state.profileSlice;
export const { UP_DATE_PROFILE } = profileSlice.actions;
export default profileSlice.reducer;
